export const NewsGallerySideBarIntl = [
  {
    en: "Press Release",
    id: "Rilis Pers",
    ch: "新闻稿",
  },
  {
    en: "Community Activities",
    id: "Kegiatan Komunitas",
    ch: "社区活动",
  },
  {
    en: "Gallery",
    id: "Galeri",
    ch: "画廊",
  },
  {
    en: "Publication",
    id: "Publikasi",
    ch: "Publication",
  },
];
